/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2BoardsClipboardIcon1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Tysiav2BoardsClipboardIcon from 'DesignSystem/Svgs/Tysiav2BoardsClipboardIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2BoardsClipboardIcon1({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon/Icon/Tysiav2BoardsClipboardIcon",
  height,
  width
  
}) {
let iconColorValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'color',
})
  return (<React.Fragment
>
<Tysiav2BoardsClipboardIcon
  viewPath={`${viewPath}/Tysiav2BoardsClipboardIcon`}
 data="icon.color"
 fill2={iconColorValueData}
 height={height}
 width={width}
/>
{children}
</React.Fragment>)
}